export enum PreferenceKey {
    DIGEST = "DIGEST",
    DIGEST_FETCHED_AT = "DIGEST_FETCHED_AT",
    LAST_SYNC_TIME = "LAST_SYNC_TIME",
    USER = "USER",
}